// Import de bibliotecas principais
import React, { Fragment } from 'react'

// Import de elementos de estilização, componentes gerais e de layout
import {
	motion,
	useScroll,
	useTransform,
} from 'framer-motion/dist/framer-motion'
import { useMediaQuery } from 'react-responsive'
import { VagaItem, Title } from '../../../components/main'

import './Basic.scss'

export function Basic({ data, refMain }) {
	const isMobile = useMediaQuery({ query: '(max-width: 1000px)' })
	const { scrollYProgress } = useScroll({
		target: refMain,
		offset: !isMobile ? ['0.225 1', '1.2 0'] : ['0.295 1', '1.2 0'],
	})
	const parallax = useTransform(scrollYProgress, [0, 1], [0, 1000])

	const textLetters = data.texto.split(' ')
	const letterVariants = {
		initial: {
			opacity: 0,
			x: 30,
			transition: {
				duration: 2,
				type: 'spring',
			},
		},
		show: {
			opacity: 1,
			x: 0,
			transition: {
				duration: 2,
				type: 'spring',
			},
		},
	}

	return (
		<motion.section
			className="basic"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			style={{
				'--secondaryColor': data.corDoTituloSecundaria,
			}}
		>
			{data.cor != '#ffffff' ? (
				<motion.div
					style={{ background: data.cor }}
					className="basic__background"
				></motion.div>
			) : (
				<></>
			)}
			<motion.div className="basic__wrapper wrapper">
				{data.titulo ? (
					<Title
						id={data.identificacao}
						isAbsolute
						initial={{
							color: data.corDoTitulo,
							top: data.tituloOffset,
							opacity: 0,
							x: -50,
						}}
						whileInView={{
							opacity: 1,
							x: 0,
							transition: {
								type: 'spring',
							},
						}}
						style={{ y: parallax }}
						transition={{
							duration: 0.5,
						}}
						viewport={{
							margin: '0px 0px -50px 0px',
							once: 'true',
						}}
						dangerouslySetInnerHTML={{ __html: data.titulo }}
					></Title>
				) : (
					<></>
				)}
				{data.texto ? (
					<motion.p style={{ color: data.corDoTexto, y: parallax }}>
						{textLetters.map((letter, i) =>
							letter !== '|' ? (
								<motion.span
									variants={letterVariants}
									key={letter + i}
									initial="initial"
									whileInView="show"
									viewport={{
										margin: '-30% 0px',
										once: 'true',
									}}
								>
									{letter + ' '}
								</motion.span>
							) : (
								<Fragment key={letter + i}>
									<br />
									<br />
								</Fragment>
							)
						)}
					</motion.p>
				) : (
					<></>
				)}
				{data.vagas ? (
					<motion.ul style={{ y: parallax }} className="basic__list">
						{data.vagas.map((vaga, i) => (
							<VagaItem
								key={`vaga-${i}`}
								data={vaga}
								isLast={i + 1 === data.vagas.length}
							/>
						))}
					</motion.ul>
				) : (
					<></>
				)}
				{data?.hasVagas ? (
					<motion.a
						href="https://loures.gupy.io/"
						className="basic__gupy"
						target="_blank"
						style={{ y: parallax }}
					>
						Saiba mais sobre as vagas
					</motion.a>
				) : null}
			</motion.div>
		</motion.section>
	)
}
